import { render, staticRenderFns } from "./ticketv.vue?vue&type=template&id=bc9cc42c&"
import script from "./ticketv.vue?vue&type=script&lang=js&"
export * from "./ticketv.vue?vue&type=script&lang=js&"
import style0 from "./ticketv.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports